import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=2ecdd5ec"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
import style0 from "./Channel.vue?vue&type=style&index=0&id=2ecdd5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports